import { TargetSkillProfileUserStatesV1NaptimeResource } from './__generated__/TargetSkillProfileUserStatesV1';

class TargetSkillProfileUserStates extends TargetSkillProfileUserStatesV1NaptimeResource {
  static RESOURCE_NAME = 'targetSkillProfileUserStates.v1' as const;
}

export default TargetSkillProfileUserStates;
